import { settings } from '@alme/ui-web/settings/settings-util';
import { AlmeState } from '@alme/ui-web/wireup/AlmeState';
import { Store } from 'redux';
import * as Actions from './actions/actions';
import reducer from './reducers/index';
import { waitForIvaFunction } from '../lib-alight-library/lib-alight-library';
export default class PlatformIdProcessor {

    _settings: typeof settings;
    _store: Store<AlmeState> | undefined;

    constructor(passedSettings: typeof settings) {
        this._settings = passedSettings || settings;
    }

    initialize(store: Store<AlmeState>) {
        this._store = store;
    }

    getReducer() {
        return reducer;
    }

    getPromise() {
        if (this.shouldAct()) {
            return this.savePlatformId();
        }

        return Promise.resolve();
    }
    shouldAct()
    {
        return true;
    }
    savePlatformId(){
        waitForIvaFunction().then((result) => {
            if (result == true) {
                const windowBase = this._settings.stateLocations.Window.Base;
                //@ts-ignore
                const platformIdLocation = this._settings.stateLocations.Window.platformId;
                const stateLocation = `${windowBase}.${platformIdLocation}`;
                if (this._store) {

                    if (window.enableIVAasService) {
                        const initData = window.enableIVAasService();
                        if (initData && initData.platformId != null && initData.platformId != undefined) {
                            const platformId = initData.platformId;
                            this._store.dispatch(Actions.savePlatformId({ stateLocation, platformId }));
                        }
                    }
                }
                return Promise.resolve();
            }
        });
    }
}


// WEBPACK FOOTER //
// ./modules/platform-id-processor/platform-id-processor.ts